import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import { createFuelTank, editFuelTank } from 'features/fuelManagement/fuelManagementSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { ITanksSensorListSingleResponse } from 'types/fuelManagement.interface'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const TanksModal = ({ closeModal, value }: { closeModal: any, value?: ITanksModal }) => {
    const [state, setState] = useState(value || {
        name: '',
        capacity: null,
        sensor: null
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        const resp = await dispatch(value?.id ? editFuelTank(state) : createFuelTank(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState({
            ...state,
            [e.target.name]: e.target.type === 'number' ? Number(e.target.value) : e.target.value
        })
    }

    const parseVehicles = (data: ITanksSensorListSingleResponse[]) => {
        return data
            ? data.map((item) => {
                const type = item.provider == 2 ? 'almaksVehicle' : item.provider == 3 ? 'develonVehicle' : 'frotcomVehicle'
                let label = item[type][item.provider == 2 ? 'name' : item.provider == 3 ? 'equipmentId' : 'model']
                if (item.provider == 1) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //  @ts-ignore
                    label = item[type].manufacturer + ' ' + (item[type].model || ' ') + ' ' + item[type].licensePlate
                }
                return {
                    label,
                    value: String(item[type].id) + '_' + String(item.provider)
                }
            })
            : []
    }


    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Tank</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input placeholder='Tanker 1...' labelText='Name' name='name' value={state.name} onChange={handleChange} nomarg required invalid={!state.name} />
                <Input placeholder='15000.' labelText='Capacity' name='capacity' value={state.capacity} onChange={handleChange} nomarg type='number' required invalid={!state.capacity} />
                <HonestSelectAsyncInput
                    link='fuel/management/tank/sensor/list'
                    placeholder='Search vehicles'
                    name='sensor'
                    labelText='Sensor'
                    onChange={(value: ISelectValue) => setState({ ...state, sensor: value })}
                    parserFunction={parseVehicles}
                    noPagination
                    defaultValue={state?.sensor?.label}
                />
            </Flex>
            <Button mt='16' disabled={!state.name || !state.capacity} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface ITanksModal {
    id?: number
    name: string
    capacity: number
    sensor: ISelectValue
}
